const onboarding = {
  businessLogic: {
    title: 'Geschäftslogik',

    areasOfOpertaion: {
      title: 'Einsatzbereiche',
      subTitle: 'state or just a neighborhood, it is up to you.,Zeigen Sie uns, wo Sie tätig sind. Wählen Sie eine ganze Stadt, ein Bundesland oder nur ein Viertel. Die Wahl liegt bei Ihnen., state or just a neighborhood, it is up to you.',
      hideLightZones: 'Hervorhebungszonen',
    },

    operationPreferences: {
      title: 'Betriebseinstellungen',
      subTitle: 'Helfen Sie uns, Sie besser kennenzulernen.',

      form: {
        sections: {
          operationPrefernces: {
            header: 'Welche Betriebspräferenzen haben Sie?',
            operationPreferncesOptions: {
              singleRides: 'Einzelfahrten',
              sharedRides: 'Mitfahrgelegenheiten',
            },
          },

          routingSettings: {
            header: 'Routing-Einstellungen',
            info: 'Max. Dauer: Maximale Dauer einer Fahrt. Max. Stopp: Maximale Stopps pro Fahrt. Verhältnis: 1,5 bedeutet, dass die Dauer, die eine Person im Fahrzeug sitzt, 150 % der Zeit, die sie alleine gefahren wäre, nicht überschreitet. Max. Fahrgäste - Maximale Anzahl an Sitzplätzen pro Fahrt.',

            fields: {
              maxDuration: 'Maximale Dauer',
              paxAtOnce: 'Personen gleichzeitig',
              maxStops: 'Max. Stopps',
              jobsAtOnes: 'Jobs gleichzeitig',
              maxPassengers: 'Max. Passagiere',
              rate: 'Rate',
              pickAll: 'Alle auswählen',
            },
          },

          pickSettings: {
            header: 'Einstellungen auswählen',
            info: 'Max. Dauer: Maximale Dauer einer Fahrt. Max. Stopp: Maximale Stopps pro Fahrt. Verhältnis: 1,5 bedeutet, dass die Dauer, die eine Person im Fahrzeug sitzt, 150 % der Zeit, die sie alleine gefahren wäre, nicht überschreitet. Max. Fahrgäste - Maximale Anzahl an Sitzplätzen pro Fahrt.',

            fields: {
              ambulatory: 'Ambulant (Min.)',
              wheelchair: 'Rollstuhl (Min.)',
              maxEarly: 'Max. Früh (Min)',
              maxLate: 'Max. Verspätung (Min.)',
            },
          },

          dropSettings: {
            header: 'Ausstiegs-Einstellungen',
            info: 'Max. Dauer: Maximale Dauer einer Fahrt. Max. Stopp: Maximale Stopps pro Fahrt. Verhältnis: 1,5 bedeutet, dass die Dauer, die eine Person im Fahrzeug sitzt, 150 % der Zeit, die sie alleine gefahren wäre, nicht überschreitet. Max. Fahrgäste - Maximale Anzahl an Sitzplätzen pro Fahrt.',

            fields: {
              ambulatory: 'Ambulant (Min.)',
              wheelchair: 'Rollstuhl (Min.)',
              maxEarly: 'Max. Früh (Min)',
              maxLate: 'Max. Verspätung (Min.)',
            },
          },
        },
      },
    },

    fleetDefenition: {
      title: 'Flottendefinition',
      subTitle: 'Jetzt, Lets talk fleet. Almost Done!',

      form: {
        sections: {
          assignmentPreferences: {
            header: 'Was sind Ihre allgemeinen Präferenzen für die Fahrerzuweisung?',
            fields: {
              defaultCarLocation: 'Standard-Autostandort (Adresse)',
              maxDuration: 'Maximale Schichtdauer (Minuten)',
            },
            assignmenOptions: {
              leastVehicles: 'Geringste Anzahl <br/> von Fahrzeugen',
              balacedVehicles: 'Ausgewogenes Routing',
            },
          },

          vehiclesAndDrivers: {
            header: 'Wie viele Fahrzeuge und Fahrer gibt es?',
            vehicles: 'Fahrzeuge',
            drivers: 'Fahrer',

            quickEntry: {
              header: 'SCHNELLEINGABE',
              fields: {
                numberOfVehicles: 'Anzahl der Fahrzeuge',
                wheelChairVehicles: 'Rollstuhlfahrzeuge',
                numberOfDrivers: 'Anzahl der Fahrer',
                wheelChairDrivers: 'Rollstuhlfahrer',
              },
            },

            files: {
              header: 'specify your In & Out Locations,Bitte geben Sie Ihre Ein- und Ausgangsorte an, specify your In & Out Locations',
              explanation: 'Erklärung, was es genau bedeutet. Erklärung und noch mehr Erklärung, und das könnte genug sein.',
              example: 'Please make sure to address all attributes properly. ',
              exampleFileText: 'Für das beste Ergebnis nutzen Sie bitte unsere',
              exampleFile: 'Beispieldatei',
              trySampleText: 'No data? ',
              trySampleBtn: 'Probieren Sie eine Probe.',
            },

            uploadData: {
              header: 'DATEN HOCHLADEN',
              firstLine: 'Bitte achten Sie darauf, alle Attribute richtig auszufüllen. Für das beste Ergebnis fühlen',
              secondLine: {
                firsTpart: 'kostenlos nutzen Sie unsere',
                vehicle: 'Beispieldatei für Fahrzeuge',
                and: 'und',
                drivers: 'Beispieldatei für Fahrer',
              },
            },
          },
        },
      },
    },

    scheduleAutomation: {
      title: 'Zeitplanautomatisierung',
      subTitle: 'Helfen Sie uns, Sie besser kennenzulernen.',
    },

    additionalFeatures: {
      title: 'Zusätzliche Funktionen',
      subTitle: 'Je mehr wir wissen, desto besser können wir unseren Dienst anbieten.',

      form: {
        file: {
          header: 'specify your In & Out Locations,Bitte geben Sie Ihre Ein- und Ausgangsorte an, specify your In & Out Locations',
          explanation: 'Erklärung, was es genau bedeutet. Erklärung und noch mehr Erklärung, und das könnte genug sein.',
          example: 'Please make sure to address all attributes properly. ',
          exampleFileText: 'Für das beste Ergebnis nutzen Sie bitte unsere',
          exampleFile: 'Beispieldatei',
          trySampleText: 'No data? ',
          trySampleBtn: ' Try a sample.',
        },

        willCall: {
          header: 'Do you wish to enable the "Will Call" option?',
          info: 'Max. Dauer: Maximale Dauer einer Fahrt. Max. Stopp: Maximale Stopps pro Fahrt. Verhältnis: 1,5 bedeutet, dass die Dauer, die eine Person im Fahrzeug sitzt, 150 % der Zeit, die sie alleine gefahren wäre, nicht überschreitet. Max. Fahrgäste - Maximale Anzahl an Sitzplätzen pro Fahrt.',
          on: 'An',
          off: 'Aus',
          time: 'Zeit',
          attribute: 'Attribut',
          explanation: 'Bitte achten Sie darauf, die Attribut-Eigenschaft in Ihren Demand-Dateien zu adressieren',
        },
      },
    },
  },

  assets: {
    title: 'Vorzüge',
    fleetDefinition: {
      title: 'Flottendefinition',
      subTitle: 'Jetzt, Lets talk fleet. Almost Done!',
    },
  },

  demand: {
    title: 'Nachfrage',

    dataUpload: {
      title: 'Daten-Upload',
      subTitle: 'Geben Sie mir die Nachfrage und wir sind bereit loszulegen!',

      form: {
        file: {
          explanation: 'Please make sure to address all attributes properly. For the best result feel ',
          example: 'kostenlos nutzen Sie unsere',
          exampleFile: 'Beispieldatei',
          trySampleText: 'Keine Daten?',
          trySampleBtn: 'Probieren Sie eine Probe.',
        },
      },
    },
  },

  save: 'Nächste',

  kpi: {
    title: 'ABGESCHLOSSENE SCHRITTE',
    wellDone: 'Gut gemacht!',
    labels: {
      onboardingKpiCompleted: 'Vollendet',
    },
  },

  submit: {
    text: 'go ahead and create you custom scenario.,Und das war\'s! Wir sind bereit. Wenn Sie mit Ihren Antworten zufrieden sind und nichts ändern möchten, können Sie Ihr benutzerdefiniertes Szenario erstellen., go ahead and create you custom scenario.',
    create: 'SZENARIO ERSTELLEN',
  },
};

export default onboarding;
